// ********************************************************
// Rules
// Definitions of some commen validation rules.
// Each rule should return either true or a String, the
// error message.
// The rules only validates on the value. They are
// generel resuable via Vue mixin.
// ********************************************************

import { app } from '@/main'

export default {
  computed: {
    rules () {
      return {
        required: value => {
          if (value === null || value === undefined || ('' + value).trim() === '' || ('' + value).trim() === '0') {
            return app != null ? app.$t('Field is required') : 'Field is required'
          } else return true
        },
        email: value => {
          const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
          if (!re.exec(value)) return app != null ? app.$t('Incorrect email') : 'Incorrect email'
          else return true
        },
        emailsOptional: value => {
          // Tests ok here: https://regex101.com/r/bQ2uM7/1
          const re = /([\w.-]+@([\w.-]+)\.+\w{2,}, )+([\w.-]+@([\w.-]+)\.+\w{2,}$)|(^[\w.-]+@([\w.-]+)\.+\w{2,}$)/i
          if (value && !re.exec(value)) return app != null ? app.$t('Incorrect emails') : 'Incorrect emails'
          else return true
        },
        username: value => {
          // Tests ok here: https://regex101.com/r/bQ2uM7/1
          const re = /^[a-z0-9_.]+$/i
          if (value === undefined || !re.exec(value)) return app != null ? app.$t('Invalid. Can only contain letters, numbers, underscores or dots') : 'Invalid. Can only contain letters, numbers, underscores or dots'
          else return true
        },
        gpsPosition: value => {
          // Tests ok here: https://regex101.com/r/evdhP2/1
          const re = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?),\s*?(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/i
          if (value === undefined || !re.exec(value)) return app != null ? app.$t('Invalid. Must be latitude, longitude ex. 56.2050474, 10.1857118 (Scanvaegt Systems A/S)') : 'Invalid. Must be latitude, longitude ex. 56.2050474, 10.1857118'
          else return true
        },
        requiredItems: value => {
          // value must not be null, undefinded or '' and must have a length > 0
          if (value == null || value === undefined || ('' + value).trim() === '' || value.length === 0) {
            return app != null ? app.$t('Field is required') : 'Field is required'
          } else return true
        },
        ipWithPort: value => {
          // Tests ok here: https://regex101.com/ ex. 0.0.0.0:1234
          const re = /(25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?)\.((25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?|[0-9])\.){2}(25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?):([1-9]|[1-9][\d]|[1-9][\d][\d]|[1-9][\d][\d][\d])$/i
          if (value === undefined || !re.exec(value)) return app != null ? app.$t('Invalid. Must be ex. 127.0.0.1:1234') : 'Invalid. Must be ex. 127.0.0.1:1234'
          else return true
        },
        ip: value => {
          // Tests ok here: https://regex101.com/ ex. 0.0.0.0
          const re = /(25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?)\.((25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?|[0-9])\.){2}(25[0-4]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?)$/i
          if (!re.exec(value)) return app != null ? app.$t('Invalid. Must be ex. 127.0.0.1') : 'Invalid. Must be ex. 127.0.0.1'
          else return true
        },
        number: value => {
          if (!value.trim()) return true
          if (!isNaN(parseFloat(value))) return true
          return app != null ? app.$t('Not a number') : 'Not a number'
        }
      }
    }
  }
}
